import axios from 'axios';
import config from '../configuration/config';
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";

export const login = async (
    credentials: { username: string; password: string },
    setUser: (user: any) => void,
    setToken: (token: string | null) => void
) => {
    try {
        const response = await axios.post(`${config.API_URL}/auth/login`, credentials);
        const token = response.data?.access_token;
        
        if (token) {
            localStorage.setItem('access_token', token);
            Cookies.set('access_token', token, { expires: 1 / 24 });

            const decodedToken = jwtDecode(token);
            setUser(decodedToken);
            setToken(token);
            localStorage.setItem("user", JSON.stringify(decodedToken)); 
        }
        
        return response.data;
    } catch (error) {
        console.error('API login error:', error);
        throw new Error('Login failed');
    }
};

export const getToken = () => {
    try {
        const localToken = localStorage.getItem('access_token');
        const cookieToken = Cookies.get('access_token');

        return localToken || cookieToken || null;
    } catch (error) {
        console.error("❌ Error getting token:", error);
        return null;
    }
};

export const logout = () => {
    localStorage.removeItem('access_token');
    Cookies.remove('access_token');
};
